import { myFetch, HttpMethod } from './baseService';

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface Mascota {
  mas_codigo?: string | number;
  mas_nombre?: string;
  mas_tipo_mascota_codigo?: string;
  mas_tipo_mascota_nombre?: string;
  mas_raza?: string;
  mas_foto_nombre?: string;
  mas_foto_ruta?: string;
  mas_unidad_residencial_codigo?: string;
  mas_torre_codigo?: string;
  mas_torre_nombre?: string;
  mas_apartamento_codigo?: string;
  mas_apartamento_nombre?: string;
  mas_esta_perdida?: string;
  [key: string]: any;
}

export interface ObtenerMascotasPerdidasRequest {
  unidad_residencial_codigo: string;
  torre_codigo: string;
  apartamento_codigo: string;
  mascota_codigo: string;
  esta_perdida: string;
}

export interface ObtenerMascotaDetalleRequest {
  unidad_residencial_codigo: string;
  torre_codigo: string;
  apartamento_codigo: string;
  mascota_codigo: string;
  esta_perdida: string;
}

export interface ReportarMascotaEncontradaRequest {
  mascota_codigo: string;
  encontrado_por_apartamento_code: string;
  encontrado_por_tipo_usuario_code: string;
}

export const obtenerMascotasPerdidas = async (payload: ObtenerMascotasPerdidasRequest) => {
  const requestPayload = {
    unidad_residencial_codigo: String(payload.unidad_residencial_codigo || ""),
    torre_codigo: String(payload.torre_codigo || ""),
    apartamento_codigo: String(payload.apartamento_codigo || ""),
    mascota_codigo: String(payload.mascota_codigo || ""),
    esta_perdida: String(payload.esta_perdida || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<Mascota[]>>(
    'mascota/ObtenerTodos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

export const obtenerMascotaDetalle = async (payload: ObtenerMascotaDetalleRequest) => {
  const requestPayload = {
    unidad_residencial_codigo: String(payload.unidad_residencial_codigo || ""),
    torre_codigo: String(payload.torre_codigo || ""),
    apartamento_codigo: String(payload.apartamento_codigo || ""),
    mascota_codigo: String(payload.mascota_codigo || ""),
    esta_perdida: String(payload.esta_perdida || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<Mascota[]>>(
    'mascota/ObtenerTodos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

export const reportarMascotaEncontrada = async (payload: ReportarMascotaEncontradaRequest) => {
  const requestPayload = {
    mascota_codigo: String(payload.mascota_codigo),
    encontrado_por_apartamento_code: String(payload.encontrado_por_apartamento_code || ""),
    encontrado_por_tipo_usuario_code: String(payload.encontrado_por_tipo_usuario_code || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<any>>(
    'mascota/Reportar_Encontrada',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

